<template>
  <div>
    <transition name="el-zoom-in-top">
      <publicity v-if="showPublicity"/>
    </transition>
    <navbar/>
    <appMain/>
    <bottom-content/>
    <transition name="el-fade-in-linear">
      <div id="return-top" v-if="showTip" @click="back">返回顶部</div>
    </transition>
  </div>
</template>

<script>
import { AppMain, BottomContent, Navbar, Publicity } from './menu_components'
export default {
  name: 'Layout',
  components: {
    AppMain,
    BottomContent,
    Navbar,
    Publicity
  },
  data () {
    return {
      showPublicity: true,
      showTip: false,
      sTop: 0
    }
  },
  watch: {
    $route (to, from) {
      console.log(to.path)
      if (to.path === '/home') {
        this.showPublicity = true
      } else {
        this.showPublicity = false
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.showReturn, false)
  },
  methods: {
    /**
     * - 显示返回按钮
     */
    showReturn () {
      this.sTop = document.documentElement.scrollTop || document.body.scrollTop

      if (this.sTop >= 570) {
        this.showTip = true
      } else {
        this.showTip = false
      }
    },
    /**
     * - 返回顶部
     */
    back () {
      this.scrollTop(window, this.sTop, 0, 1000)
    },
    /**
     * - scrollTop animation
     */
    scrollTop (el, from = 0, to, duration = 500, endCallback) {
      if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = (
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.msRequestAnimationFrame ||
          function (callback) {
            return window.setTimeout(callback, 1000 / 60)
          }
        )
      }
      const difference = Math.abs(from - to)
      const step = Math.ceil(difference / duration * 50)

      function scroll (start, end, step) {
        if (start === end) {
          endCallback && endCallback()
          return
        }

        let d = (start + step > end) ? end : start + step
        if (start > end) {
          d = (start - step < end) ? end : start - step
        }

        if (el === window) {
          window.scrollTo(d, d)
        } else {
          el.scrollTop = d
        }
        window.requestAnimationFrame(() => scroll(d, end, step))
      }
      scroll(from, to, step)
    }
  }
}
</script>

<style lang="scss" scoped>
#return-top {
  width: 100px;
  height: 50px;
  right: calc(1vw * 2);
  bottom: calc(1vh * 10);
  text-align: center;
  line-height: 50px;
  color: #fff;
  position: fixed;
  background: #cfcfcf;
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue